import { DateTime } from "luxon";

export function getUTCIntegerTimeFromClientInput(date, hour, minute, swaStation) {
  console.log(`getUTCIntegerTimeFromClientInput(${date}, ${hour}, ${minute}, ${swaStation})`);
  if (!date) {
    return null;
  }
  const { DateTime } = require("luxon");
  let dateString = getDateOnlyFromClientDateTimeString(date) + "-" + hour + ":" + minute;
  let dateFormat = "yyyy-MM-dd-HH:mm";
  let swaStationTimeZone = getTimeZoneFromSwaStation(swaStation);
  let luxonDateTime = DateTime.fromFormat(dateString, dateFormat, { zone: swaStationTimeZone });
  let UTCint = luxonDateTime.toMillis();
  return UTCint.toString;
}

export function getStationTimeZoneDateTimeStringFromUTCInteger(UTCInteger, swaStation) {
  let luxonDateTime = DateTime.fromMillis(parseInt(UTCInteger), { zone: getTimeZoneFromSwaStation(swaStation) });
  return luxonDateTime;
}

export function getTimeZoneDateTimeStringFromUTCInteger(UTCInteger, timezone) {
  let luxonDateTime = DateTime.fromMillis(parseInt(UTCInteger), { zone: timezone });
  return luxonDateTime;
}

export const getLastUpdatedTimeString = (createdAt, timezone) => {
  if (createdAt.toString().length === 10) {
    createdAt = createdAt * 1000;
  }

  return getTimeZoneDateTimeStringFromUTCInteger(createdAt, timezone).toFormat("MM/dd/yyyy T ZZZZ");
};

export function getStationTimeZoneLuxonDateTimeFromIsoDateString(isoDateString, swaStation) {
  let luxonDateTime = DateTime.fromFormat(isoDateString, "yyyy-MM-dd", { zone: getTimeZoneFromSwaStation(swaStation) });
  return luxonDateTime;
}

export function getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(isoDateString, swaStation) {
  let luxonDateTime = DateTime.fromISO(isoDateString, { zone: getTimeZoneFromSwaStation(swaStation) });
  return luxonDateTime;
}

export function convertTradeFormEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(tradeFormEvent) {
  tradeFormEvent.createdAt = getStationTimeZoneDateTimeStringFromUTCInteger(
    tradeFormEvent.createdAt,
    tradeFormEvent.station
  );
  if (tradeFormEvent.customCreatedAt && tradeFormEvent.customCreatedAt !== "") {
    // If a trade event contains a customCreatedAt time we need to overwrite the createdAt time for display
    tradeFormEvent.createdAt = getStationTimeZoneDateTimeStringFromUTCInteger(
      tradeFormEvent.customCreatedAt,
      tradeFormEvent.station
    );
  }
  tradeFormEvent.offeredShiftStart = getStationTimeZoneDateTimeStringFromUTCInteger(
    tradeFormEvent.offeredShiftStart,
    tradeFormEvent.station
  );
  tradeFormEvent.offeredShiftEnd = getStationTimeZoneDateTimeStringFromUTCInteger(
    tradeFormEvent.offeredShiftEnd,
    tradeFormEvent.station
  );
  if (tradeFormEvent.requestedShiftStart) {
    tradeFormEvent.requestedShiftStart = getStationTimeZoneDateTimeStringFromUTCInteger(
      tradeFormEvent.requestedShiftStart,
      tradeFormEvent.station
    );
    tradeFormEvent.requestedShiftEnd = getStationTimeZoneDateTimeStringFromUTCInteger(
      tradeFormEvent.requestedShiftEnd,
      tradeFormEvent.station
    );
  }
  return tradeFormEvent;
}

export function convertTimeOffRequestSnapshotUTCIntegerFieldsToStationTimeZoneLuxonDateTime(timeOffRequestSnapshot) {
  timeOffRequestSnapshot.lastUpdatedDate = getStationTimeZoneDateTimeStringFromUTCInteger(
    timeOffRequestSnapshot.lastUpdatedDate,
    timeOffRequestSnapshot.station
  );

  timeOffRequestSnapshot.shiftStart = getStationTimeZoneDateTimeStringFromUTCInteger(
    timeOffRequestSnapshot.shiftStart,
    timeOffRequestSnapshot.station
  );

  timeOffRequestSnapshot.shiftEnd = getStationTimeZoneDateTimeStringFromUTCInteger(
    timeOffRequestSnapshot.shiftEnd,
    timeOffRequestSnapshot.station
  );

  if (timeOffRequestSnapshot.submittedDate)
    timeOffRequestSnapshot.submittedDate = getStationTimeZoneDateTimeStringFromUTCInteger(
      timeOffRequestSnapshot.submittedDate,
      timeOffRequestSnapshot.station
    );

  if (timeOffRequestSnapshot.approvedDate)
    timeOffRequestSnapshot.approvedDate = getStationTimeZoneDateTimeStringFromUTCInteger(
      timeOffRequestSnapshot.approvedDate,
      timeOffRequestSnapshot.station
    );

  return timeOffRequestSnapshot;
}

export function convertTimeOffRequestEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(timeOffRequestEvent) {
  timeOffRequestEvent.createdAt = getStationTimeZoneDateTimeStringFromUTCInteger(
    timeOffRequestEvent.createdAt,
    timeOffRequestEvent.station
  );

  timeOffRequestEvent.shiftStart = getStationTimeZoneDateTimeStringFromUTCInteger(
    timeOffRequestEvent.shiftStart,
    timeOffRequestEvent.station
  );

  timeOffRequestEvent.shiftEnd = getStationTimeZoneDateTimeStringFromUTCInteger(
    timeOffRequestEvent.shiftEnd,
    timeOffRequestEvent.station
  );

  return timeOffRequestEvent;
}

export function convertTempAssignmentSnapshotUTCIntegerFieldsToStationTimeZoneLuxonDateTime(
  tempAssignmentSnapshot,
  station
) {
  tempAssignmentSnapshot.lastUpdatedDate = getStationTimeZoneDateTimeStringFromUTCInteger(
    tempAssignmentSnapshot.lastUpdatedDate,
    station
  );

  tempAssignmentSnapshot.startDate = getStationTimeZoneLuxonDateTimeFromIsoDateString(
    tempAssignmentSnapshot.startDate,
    station
  );

  tempAssignmentSnapshot.endDate = getStationTimeZoneLuxonDateTimeFromIsoDateString(
    tempAssignmentSnapshot.endDate,
    station
  );

  return tempAssignmentSnapshot;
}

export function convertUserAccessOverrideEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(userAccessOverrideEvent) {
  userAccessOverrideEvent.createdAt = getStationTimeZoneDateTimeStringFromUTCInteger(
    userAccessOverrideEvent.createdAt,
    userAccessOverrideEvent.station
  );
  return userAccessOverrideEvent;
}

export function convertUTCIntegerFieldToStationTimeZoneLuxonDateTime(utcInteger, station) {
  return getStationTimeZoneDateTimeStringFromUTCInteger(utcInteger, station);
}

export function convertBidEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(bidEvent) {
  bidEvent.createdAt = getStationTimeZoneDateTimeStringFromUTCInteger(bidEvent.createdAt, bidEvent.station);

  if (bidEvent.windowStartDate) {
    bidEvent.windowStartDate = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(
      bidEvent.windowStartDate,
      bidEvent.station
    );
  }

  if (bidEvent.windowEndDate) {
    bidEvent.windowEndDate = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(
      bidEvent.windowEndDate,
      bidEvent.station
    );
  }

  if (bidEvent.schedStartDate) {
    bidEvent.schedStartDate = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(
      bidEvent.schedStartDate,
      bidEvent.station
    );
  }

  if (bidEvent.schedEndDate) {
    bidEvent.schedEndDate = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(
      bidEvent.schedEndDate,
      bidEvent.station
    );
  }

  return bidEvent;
}

export function convertBidPreferenceEventUTCIntegerFieldsToStationTimeZoneLuxonDateTime(bidPreferenceEvent) {
  bidPreferenceEvent.createdAt = getStationTimeZoneDateTimeStringFromUTCInteger(
    bidPreferenceEvent.createdAt,
    bidPreferenceEvent.station
  );

  if (bidPreferenceEvent.windowStartDate) {
    bidPreferenceEvent.windowStartDate = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(
      bidPreferenceEvent.windowStartDate,
      bidPreferenceEvent.station
    );
  }

  if (bidPreferenceEvent.windowEndDate) {
    bidPreferenceEvent.windowEndDate = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(
      bidPreferenceEvent.windowEndDate,
      bidPreferenceEvent.station
    );
  }

  if (bidPreferenceEvent.schedStartDate) {
    bidPreferenceEvent.schedStartDate = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(
      bidPreferenceEvent.schedStartDate,
      bidPreferenceEvent.station
    );
  }

  if (bidPreferenceEvent.schedEndDate) {
    bidPreferenceEvent.schedEndDate = getStationTimeZoneLuxonDateTimeFromIsoDateTimeString(
      bidPreferenceEvent.schedEndDate,
      bidPreferenceEvent.station
    );
  }

  return bidPreferenceEvent;
}

const swaStationToTimeZoneObject = {
  ABQ: "America/Denver",
  ALB: "America/New_York",
  AMA: "America/Chicago",
  ATL: "America/New_York",
  AUS: "America/Chicago",
  BDL: "America/New_York",
  BHM: "America/Chicago",
  BLI: "America/Los_Angeles",
  BNA: "America/Chicago",
  BOI: "America/Denver",
  BOS: "America/New_York",
  BUF: "America/New_York",
  BUR: "America/Los_Angeles",
  BWI: "America/New_York",
  BZN: "America/Denver",
  CHS: "America/New_York",
  CLE: "America/New_York",
  CLT: "America/New_York",
  CMH: "America/New_York",
  COS: "America/Denver",
  CRP: "America/Chicago",
  CVG: "America/New_York",
  DAL: "America/Chicago",
  DCA: "America/New_York",
  DEN: "America/Denver",
  DTW: "America/New_York",
  ECP: "America/Chicago",
  ELP: "America/Denver",
  FAT: "America/Los_Angeles",
  FLL: "America/New_York",
  GEG: "America/Los_Angeles",
  GRR: "America/New_York",
  GSP: "America/New_York",
  HNL: "Pacific/Honolulu",
  HOU: "America/Chicago",
  HRL: "America/Chicago",
  IAD: "America/New_York",
  IAH: "America/Chicago",
  ICT: "America/Chicago",
  IND: "America/New_York",
  ISP: "America/New_York",
  ITO: "Pacific/Honolulu",
  JAN: "America/Chicago",
  JAX: "America/New_York",
  KOA: "Pacific/Honolulu",
  LAS: "America/Los_Angeles",
  LAX: "America/Los_Angeles",
  LBB: "America/Chicago",
  LGA: "America/New_York",
  LGB: "America/Los_Angeles",
  LIH: "Pacific/Honolulu",
  LIT: "America/Chicago",
  MAF: "America/Chicago",
  MCI: "America/Chicago",
  MCO: "America/New_York",
  MDW: "America/Chicago",
  MEM: "America/Chicago",
  MHT: "America/New_York",
  MIA: "America/New_York",
  MKE: "America/Chicago",
  MSP: "America/Chicago",
  MSY: "America/Chicago",
  MYR: "America/New_York",
  OAK: "America/Los_Angeles",
  OGG: "Pacific/Honolulu",
  OKC: "America/Chicago",
  OMA: "America/Chicago",
  ONT: "America/Los_Angeles",
  ORD: "America/Chicago",
  ORF: "America/New_York",
  PBI: "America/New_York",
  PDX: "America/Los_Angeles",
  PHL: "America/New_York",
  PHX: "America/Phoenix",
  PIT: "America/New_York",
  PNS: "America/Chicago",
  PSP: "America/Los_Angeles",
  PVD: "America/New_York",
  RDU: "America/New_York",
  RIC: "America/New_York",
  RNO: "America/Los_Angeles",
  ROC: "America/New_York",
  RSW: "America/New_York",
  SAN: "America/Los_Angeles",
  SAT: "America/Chicago",
  SAV: "America/New_York",
  SBA: "America/Los_Angeles",
  SDF: "America/New_York",
  SEA: "America/Los_Angeles",
  SFO: "America/Los_Angeles",
  SJC: "America/Los_Angeles",
  SJU: "America/Puerto_Rico",
  SLC: "America/Denver",
  SMF: "America/Los_Angeles",
  SNA: "America/Los_Angeles",
  SRQ: "America/New_York",
  STL: "America/Chicago",
  SYR: "America/New_York",
  TPA: "America/New_York",
  TUL: "America/Chicago",
  TUS: "America/Phoenix",
  VPS: "America/Chicago",
};

export function getTimeZoneFromSwaStation(swaStation) {
  return swaStationToTimeZoneObject[swaStation];
}

const getDateOnlyFromClientDateTimeString = (clientDateTimeString) => {
  let dateOnly = clientDateTimeString.split("T")[0];
  return dateOnly;
};
